const en = {
  nav: { plans: "Plans", howItWorks: "How It Works", contact: "Contact", support: "Support", consultData: "Check Data", login: "Login", portal: "My Account", crm: "CRM", services: "Services", chipMobile: "Chip NewSky Mobile", wifiService: "NewSky WiFi" },

  hero: {
    brand: "Mobile",
    overline: "The connection you need in Japan",
    headline: "Internet + Japanese Phone Number",
    headlineAccent: "hassle-free!",
    sub: "No cancellation fees! Use it as long as you need!",
    sub2: "Physical SIM or eSIM with support in your language!",
    ctaBuy: "Get mine now!",
    ctaPlans: "View plans",
  },

  benefits: {
    overline: "Benefits",
    title: "Everything you need",
    items: [
      { title: "Stable connection across Japan", desc: "High-speed 4G/5G coverage in all regions of Japan." },
      { title: "Super affordable", desc: "Plans starting from ¥3,480/month with calls included." },
      { title: "No bureaucracy", desc: "Simple and fast process. No long-term contracts." },
      { title: "Pay at konbini or by card", desc: "Pay the way that suits you best. Konbini, credit card, or bank transfer." },
      { title: "Promotional activation fee", desc: "Take advantage of our special discounted activation fee." },
      { title: "Physical SIM or eSIM same day", desc: "Choose between physical SIM or eSIM. Instant activation." },
    ],
  },

  plans: {
    overline: "Plans",
    title: "Choose your ideal plan",
    sub: "Plans with Japanese phone number, data, and calls. Start using today.",
    basic: "Basic",
    popular: "Popular",
    premium: "Premium",
    badge: "Most Popular",
    unlimitedCalls: "Unlimited calls",
    calls60: "60 min calls",
    month: "month",
    optional: "Optional",
    unlimitedPlus: "Unlimited calls",
    activationFee: "One-time activation fee: ¥3,300",
    cta: "I want more info",
    features: {
      data: "of data",
      callsUnlimited: "Unlimited calls",
      calls60min: "60 min of calls",
      jpNumber: "Japanese phone number",
      simOrEsim: "Physical SIM or eSIM",
      supportPt: "Support in Portuguese",
      supportPriority: "Priority support",
    },
  },

  howItWorks: {
    overline: "Simple and fast",
    title: "How it works",
    steps: [
      { title: "Choose your plan", desc: "Select the ideal plan for your data and calling needs." },
      { title: "Receive your SIM or eSIM", desc: "Get your physical SIM delivered or activate your eSIM instantly." },
      { title: "Activate and use", desc: "Insert the SIM or scan the eSIM QR code. That's it, you're connected!" },
    ],
  },

  trust: {
    overline: "Trust and Tradition",
    title: "Over 25 years connecting people in Japan",
    desc: "NewSky has been present in Japan for over two decades, offering telecommunications services with dedicated support in Portuguese, Spanish, and English. Over 100,000 satisfied customers trust our experience.",
    stats: { years: "Years in Japan", customers: "Customers served", languages: "Support languages", response: "Fast response" },
    langs: ["Portuguese", "Spanish", "English"],
  },

  contact: {
    overline: "Get in touch",
    title: "Contact us",
    form: { name: "Name", email: "Email", phone: "Phone", message: "Message", namePh: "Your name", emailPh: "your@email.com", phonePh: "090-XXXX-XXXX", messagePh: "How can we help?", submit: "Send message", sending: "Sending...", success: "Message sent!", error: "Error. Try again." },
    info: { tokyo: "Tokyo", email: "Email", whatsapp: "WhatsApp", whatsappSub: "Text-only support", hours: "Business hours", monFri: "Monday to Friday", sat: "Saturday", hq: "NewSky - Headquarters", hqAddr: "163-1030 Tokyo-to Shinjuku-ku Nishi-Shinjuku 3-7-1 Shinjuku Park Tower N30F", hqNote: "(no customer service at this location)", office: "NewSky - Customer Service Office", officeAddr: "485-0048 Aichi-ken Komaki-shi MamaHonMachi 123 BB komaki Bldg. 3F" },
  },

  finalCta: {
    overline: "Don't wait any longer",
    title: "Arrive in Japan already connected",
    desc: "Have your Japanese number and internet working before you even leave the airport. Talk to us now.",
    cta: "Get mine now!",
  },

  supportPage: {
    overline: "Help Center",
    title: "How can we help?",
    sub: "Find answers to the most frequently asked questions or contact our team.",
    searchPh: "Search support...",
    faqTitle: "Frequently Asked Questions",
    noResults: "No results found for",
    needHelp: "Still need help?",
    whatsapp: "WhatsApp",
    whatsappSub: "Quick response",
    phone: "Phone",
    emailLabel: "Email",
    backHome: "Back to home",
    faqs: [
      { q: "How do I activate my eSIM?", a: "After purchase, you'll receive a QR Code by email. Go to your phone's settings, tap 'Mobile Data' or 'Cellular', select 'Add Plan' and scan the QR Code. Your eSIM will be activated in a few minutes." },
      { q: "Which phones are compatible with eSIM?", a: "Most modern smartphones are compatible, including iPhone XS and later, Samsung Galaxy S20+, Google Pixel 3 and later. Contact us on WhatsApp to check your device's compatibility." },
      { q: "Can I keep my current number?", a: "Yes! We offer number portability (MNP). You can transfer your current number to NewSky Mobile. Contact us for more details about the process." },
      { q: "How does konbini payment work?", a: "You'll receive a payment slip by email or SMS that can be paid at any konbini (7-Eleven, FamilyMart, Lawson, etc). Payment is processed within 24 hours." },
      { q: "What's the network coverage?", a: "Our network covers all of Japan, including rural areas. We use the infrastructure of Japan's major carriers, ensuring high-quality 4G/5G connectivity nationwide." },
      { q: "Can I cancel anytime?", a: "Yes! Our plans have no commitment or cancellation fees. You can cancel at any time by contacting us via WhatsApp or phone." },
      { q: "How do I receive the physical SIM?", a: "The physical SIM is delivered via Japan Post. Delivery usually takes 1-3 business days. You can also pick it up at our office in Tokyo." },
      { q: "Do I need documents to sign up?", a: "Yes, you need a valid ID document (passport or Residence Card). The process is simple and can be done entirely via WhatsApp." },
    ],
  },

  consultar: {
    title: "Check Data Usage",
    desc: "To check data consumption and your NewSky Mobile SIM card information, enter your SIM card number",
    label: "SIM Card Number",
    placeholder: "Enter your SIM number",
    button: "Check",
    consulting: "Checking...",
    result: "Query Result",
    newSearch: "New search",
    simInfo: "Your SIM card number is printed on the SIM card or can be found in your phone settings.",
    number: "Number",
    dataUsage: "Data Usage",
    used: "used",
    remaining: "remaining",
    plan: "Plan",
    network: "Network",
    sim: "SIM",
    voice: "Voice",
    sms: "SMS",
    planStart: "Plan Start",
    active: "Active",
    suspended: "Suspended",
    details: "SIM Details",
    serialNumber: "Serial Number",
    activation: "Activation",
    calls: "Calls",
    callsUnlimited: "Unlimited (70 min/call)",
    planStartDate: "Plan Start Date",
    planEndDate: "Plan End Date",
    noExpiry: "No expiration",
    error: "Error querying. Please try again.",
    notFound: "SIM not found or invalid number",
  },

  footer: { back: "Back" },

  wifi: {
    overline: "WiMAX 5G — Unlimited Internet",
    headline: "High-speed internet",
    headlineAccent: "anywhere you go!",
    sub: "No wires. No technician. No installation fees. No waiting.",
    sub2: "Unlimited internet for the whole family in seconds!",
    ctaBuy: "Get mine now!",
    ctaPlans: "View plans",
    familyText: "Internet for the whole family!",
    benefitsTitle: "Why choose NewSky WiFi?",
    benefitsOverline: "Benefits",
    benefits: [
      { title: "No wires, no installation", desc: "Plug in, power on, connect! No technician needed, no drilling, no waiting." },
      { title: "Unlimited internet", desc: "Unlimited data for streaming, work, gaming, and the whole family." },
      { title: "Take it anywhere", desc: "At home, at work, traveling. Long-lasting battery for all-day use." },
      { title: "No high fees", desc: "No absurd installation fees. No extra charges when you move." },
      { title: "Connect up to 16 devices", desc: "Phone, laptop, tablet, smart TV, gaming console — all at once." },
      { title: "5G WiMAX speed", desc: "Cutting-edge technology with maximum performance for your connection." },
    ],
    plansOverline: "Plans",
    plansTitle: "Choose your payment method",
    plansSub: "Unlimited WiMAX 5G Internet — Brand new device!",
    konbini: "💴 Konbini Payment",
    card: "💳 Automatic Credit Card",
    planSky1: "Sky Plan 1",
    planSky2: "Sky Plan 2",
    tabRent: "Rent Device",
    tabBuy: "Buy Device",
    month: "/mo",
    unlimitedRental: "Unlimited internet + device rental",
    deviceNew: "🎉 BRAND NEW DEVICE!",
    activationFee: "Activation fee",
    shippingFee: "Shipping (all Japan)",
    totalInitial: "Initial total",
    monthlyLabel: "Monthly:",
    campaign: "Special Campaign",
    buyBonus: "🎁 When you buy, you get:",
    exempt: "WAIVED",
    free: "FREE",
    shippingFree: "for all Japan",
    monthlyReduction: "Monthly fee",
    unlimitedInternet: "Unlimited internet",
    paymentKonbini: "📅 Payment between the 2nd and 15th of the following month",
    paymentCard: "💳 Automatic debit on credit card the following month",
    noCancel: "✓ No cancellation penalty",
    minPeriod: "⏱ Minimum period: 2 months",
    cta: "I want more info",
    konbiniNote: "Amount to pay the delivery person upon receiving at home:",
    cardNote: "We will send a secure invoice for card payment:",
  },

  portal: {
    loginTitle: "Customer Portal", loginSub: "Access your services and payments",
    email: "Email", emailPh: "your@email.com", password: "Password", passwordPh: "Your password",
    enter: "Sign In", demo: "Sign in with Demo account",
    forgot: "Forgot my password", forgotTitle: "Password Recovery",
    forgotDesc: "To reset your password, please contact our support:", forgotClose: "Close", backToSite: "Back to site",
    portalLabel: "Portal",
    nav: { home: "Home", services: "Services", payments: "Payments", support: "Support", account: "My Account", logout: "Logout" },
    hello: "Hello,", welcome: "Welcome to your NewSky Mobile portal",
    monthlyTotal: "MONTHLY TOTAL", pending: "PENDING",
    myServices: "My Services", viewAll: "View all", noActiveService: "No active services",
    nextBilling: "Next billing:", overdueWarning: "Warning: {count} service(s) with overdue payment",
    overdueContact: "Contact support to resolve.", pendingPayments: "Pending Payments",
    dueDate: "Due:", overdue: "OVERDUE", pendingLabel: "PENDING", month: "/mo",
    myServicesTitle: "My Services", noServiceFound: "No services found",
    since: "Since", upgrade: "Upgrade", downgrade: "Downgrade", cancel: "Cancel",
    requestTitle: "Request", requestDesc: "Describe your request...", sendRequest: "Send Request", cancelBtn: "Cancel",
    myRequests: "My Requests", reqType: "Type", reqDetails: "Details", reqDate: "Date", reqStatus: "Status",
    reqPending: "Pending", reqApproved: "Approved", reqRejected: "Rejected",
    statusActive: "ACTIVE", statusOverdue: "OVERDUE", statusCancelled: "CANCELLED",
    paymentsTitle: "Payments", totalPaid: "Total Paid", pendingAmount: "Pending", overdueAmount: "Overdue",
    openInvoices: "Open Invoices", invoices: "Invoices", payNow: "Pay Now",
    paid: "PAID", open: "OPEN", history: "History", noPayment: "No payments",
    amount: "Amount", dueDateLabel: "Due Date", paymentDate: "Payment", status: "Status",
    supportTitle: "Support", supportEmpty: "Send a message to start a conversation.",
    supportTeam: "Our team will respond shortly.", typePlaceholder: "Type your message...",
    accountTitle: "My Account", personalData: "Personal Data", name: "Name",
    nameChangeNote: "To change your name, contact support.", phone: "Phone",
    save: "Save Changes", saved: "Data updated successfully!",
  },
};

export default en;
